import React, { useState } from 'react';
import Image from 'next/image';
import PropTypes from 'prop-types';
import Button from '@components/Button/Button';
import TextField from '@components/Input/Input';
import { styled } from '@mui/material/styles';
import Add from '@mui/icons-material/Add';
import { Divider } from '@mui/material';
import Avatar from '@components/Avatar/Avatar';
import CloseIcon from '@mui/icons-material/Close';
import { Box } from '@mui/system';
import { useTheme } from 'next-themes';
import { useDispatch, useSelector } from 'react-redux';
import { setCustomAlert, setInvitedMembers } from '@redux/actions/general';
import { v4 as uuid } from 'uuid';
import { invitationCheck } from '@redux/services/teams';

// eslint-disable-next-line no-useless-escape
const emailRe =
  // eslint-disable-next-line no-useless-escape
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9] {4} {1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const Wrapper = styled('div')`
  .btn {
    background-color: #2499e7;
    color: white;
    font-family: 'Montserrat', sans-serif;
    text-transform: capitalize;
    font-weight: 600;
    padding: 15px;
    border-radius: 4px;
    min-width: '20px';
    margin-left: 10px;
  }
  .btn:hover {
    background-color: #208ad0;
  }
  .fullBtn {
    background-color: #2499e7;
    min-height: 50px;
    min-width: 100%;
    margin-top: 15px;
    padding: 10px 20px;
    color: white;
    font-family: 'Montserrat', sans-serif;
  }
  .fullBtn:hover {
    background-color: #208ad0;
  }
  .divider {
    border-color: ${({ theme }) => (theme === 'dark' ? '#1e2628' : '')};
  }
  .Mui-disabled {
    background-color: #bde0f8;
    color: white;
    font-weight: 600;
  }
`;
function InviteModal({
  teamID,
  emailInviteValue,
  setEmailInviteValue,
  handleSendEmailInvite,
  inviteSent,
  setModalType,
  teamMembers,
  addSeatLoading,
}) {
  const [inviteCheckLS, setInviteCheckLS] = useState(false);
  const [active, setActive] = useState('');
  const { theme } = useTheme();
  const dispatch = useDispatch();
  const {
    general: { invitedMembers },
  } = useSelector((state) => state);
  const handleAddMemberToList = (e) => {
    e.preventDefault();
    if (invitedMembers?.length >= 10) {
      dispatch(
        setCustomAlert({
          message: "Can't add more than 10 members at once!",
          state: true,
          type: 'info',
        })
      );
      return;
    }
    const existingUser = [...invitedMembers, ...teamMembers]?.find(
      ({ email }) => email.toLowerCase() === emailInviteValue.toLowerCase()
    );
    if (existingUser) {
      dispatch(
        setCustomAlert({
          message: 'This email already exists!',
          state: true,
          type: 'info',
        })
      );
      return;
    }
    setInviteCheckLS(true);
    invitationCheck(
      {
        email: emailInviteValue.toLowerCase(),
        count: invitedMembers?.length + 1,
      },
      teamID
    )
      .then((res) => {
        const { data } = res?.data;
        dispatch(
          setInvitedMembers({
            type: 'add',
            data: {
              email: emailInviteValue,
              avatarText: emailInviteValue?.charAt(0),
              id: uuid(),
              name: data?.user?.name || null,
            },
          })
        );
      })
      .catch((err) => {
        if (err?.message === 'Invitation limit reached') {
          setModalType('outofseats');
        } else {
          dispatch(
            setCustomAlert({
              message: err?.message || 'Something went wrong!',
              type: 'info',
              state: true,
            })
          );
        }
      })
      .finally(() => setInviteCheckLS(false));

    setEmailInviteValue('');
  };

  const handleRemoveMemberFromList = (id) => {
    const filteredMember = invitedMembers.filter(
      ({ id: memberId }) => memberId !== id
    );
    dispatch(setInvitedMembers({ type: 'remove', data: filteredMember }));
  };
  return (
    <Wrapper theme={theme}>
      <div className='text-custom-font-color dark:text-white'>
        <div>
          {!inviteSent ? (
            <>
              <form onSubmit={handleAddMemberToList}>
                <div className='text-md font-bold text-custom-font-color dark:text-white'>
                  EMAIL ADDRESS
                </div>
                <div className='pt-2 flex'>
                  <TextField
                    getValue={(event) =>
                      setEmailInviteValue(event.target.value.trim())
                    }
                    maxLength={50}
                    placeholder='Eg: JohnDoe@example.com'
                    value={emailInviteValue}
                  />
                  <Button
                    disabled={!emailRe.test(emailInviteValue) || inviteCheckLS}
                    className='btn'
                    loading={inviteCheckLS}
                  >
                    <Add />
                  </Button>
                </div>
              </form>
              {/* <div className='pt-2 text-sm'>
                Your plan has <b className='text-secondary-blue'>2</b> available
                user seat(s).
              </div> */}
              {invitedMembers?.length ? (
                <div className='mt-4 mb-1'>
                  <p className='text-sm mb-2'>
                    Enter email address to send multiple invites
                  </p>
                  <Divider className='divider' />
                </div>
              ) : null}
              <Box className='overflow-y-scroll' maxHeight='264px'>
                {invitedMembers?.length
                  ? invitedMembers?.map((member) => (
                      <div
                        key={member?.id}
                        className='flex justify-between items-center pt-2'
                      >
                        <div className='flex items-center'>
                          <Avatar title={member?.name || member?.avatarText} />
                          <div className='pl-2'>
                            {member?.name ? (
                              <div className='text-sm font-bold'>
                                {member?.name}
                              </div>
                            ) : null}
                            <div className='text-sm'>{member?.email}</div>
                          </div>
                        </div>
                        <div className='cursor-pointer'>
                          <CloseIcon
                            onClick={() =>
                              handleRemoveMemberFromList(member?.id)
                            }
                          />
                        </div>
                      </div>
                    ))
                  : null}
                {/* {!inviteSent ? (
                  <div className='flex items-center pt-5'>
                    <div className='pr-2'>
                      <AnnouncementIcon className='pr-1' />
                    </div>
                    <div className='text-[12px]'>
                      These 1 user(s) will be added to your plan <br />
                      <b>(additional $50 per user / month)</b>
                    </div>
                  </div>
                ) : null} */}
              </Box>
              <div className='mt-3'>
                <Divider className='divider' />
              </div>
            </>
          ) : (
            <div>
              <div className='flex justify-center items-center flex-col'>
                <Image
                  width={96}
                  height={96}
                  src='/assets/check_circle.png'
                  alt='check'
                />
                <p className='my-5 text-gray-700 dark:text-white'>
                  Invitation email sent successfully!
                </p>
              </div>
            </div>
          )}
          <div className='text-right pb-3'>
            {
              !inviteSent ? (
                <Button
                  loading={addSeatLoading}
                  disabled={!invitedMembers?.length || addSeatLoading}
                  onClick={handleSendEmailInvite}
                  className='fullBtn'
                >
                  Send Invite
                </Button>
              ) : null
              // <Button className='fullBtn'>Proceed to Payment</Button>
            }
          </div>
          {/* <div className='pt-3 text-sm text-custom-font-color dark:text-white flex items-start'>
          <AnnouncementIcon className='w-[18px] h-[18px] mr-2 mt-[1px]' />
          <div className='text-sm'>
            This user will be assigned a <b>TEAM SEO UNLIMITED</b> license ($50
            per user / month)
          </div>
        </div> */}
        </div>
      </div>
    </Wrapper>
  );
}

InviteModal.propTypes = {
  emailInviteValue: PropTypes.string,
  teamID: PropTypes.string,
  handleSendEmailInvite: PropTypes.func,
  inviteSent: PropTypes.bool,
  addSeatLoading: PropTypes.bool,
  setEmailInviteValue: PropTypes.func,
  setModalType: PropTypes.func,
  teamMembers: PropTypes.array,
};

export default InviteModal;
